import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import virtualTourImage from '../../../assets/icons/play.svg'

export const VirtualTourTagContainer = styled.div<{ $isSmall?: boolean }>(
    ({ theme, $isSmall }) => css`
        display: flex;
        align-items: center;
        gap: 5px;
        background: ${$isSmall ? 'rgba(245, 245, 245, 1)' : 'rgba(255, 255, 255, 0.8)'};
        padding: ${$isSmall ? '0.25rem 0.375rem' : '0.375rem 0.5rem'};
        border-radius: ${theme.typography.border.radius.medium};
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    `,
)

export const VirtualTourTextContainer = styled.div`
    display: flex;
    flex-direction: column;
`

export const VirtualTourIcon = styled(virtualTourImage)`
    width: 20px;
    height: 20px;
`

export const OverlayFooterWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: ${theme.spacing.small};
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
    `,
)

export const OverlayCTAButton = styled.button(
    ({ theme }) => css`
        width: 100%;
        padding: 0.75rem 1rem;
        border-radius: 0.75rem;
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1rem;
        cursor: pointer;
        text-align: center;
        border: 1px solid transparent;
        background-color: ${theme.colors.tfwYellow};
        color: ${theme.colors.tfwBlack99};

        &:hover {
            background-color: ${theme.colors.tfwYellowHover};
        }

        &:active {
            transform: translateY(1px);
        }
    `,
)

export const VirtualTourModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    height: 100%;
    width: 100%;
    position: relative;
    padding: 2rem;
    box-sizing: border-box;
`

export const VirtualTourVideoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: min(90%, 800px);
    margin: 0 auto;
`

export const VirtualTourCloseButton = styled.div(
    ({ theme }) => css`
        position: absolute;
        top: ${theme.spacing.medium};
        right: ${theme.spacing.medium};
        width: 3.125rem;
        height: 3.125rem;
        cursor: pointer;
        z-index: 10;
        transition:
            transform 0.3s ease,
            opacity 0.3s ease;

        &:hover {
            transform: scale(1.1);
            opacity: 0.8;
        }

        &:active {
            transform: scale(0.9);
            opacity: 0.6;
        }
    `,
)

export const virtualTourModalStyles: ReactModal.Styles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        zIndex: 9999,
    },
    content: {
        position: 'unset',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: 0,
        border: 'none',
        borderRadius: 0,
        borderWidth: 0,
        backgroundColor: 'transparent',
        maxWidth: 'min(90%, 800px)',
    },
}
